import { render } from "./HeroiconsSolidFolderAdd.vue?vue&type=template&id=63879046"
const script = {}

import exportComponent from "/Users/larkinwhitaker/Projects/eye-rep/modules/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidFolderAdd.vue"]])

export default __exports__